import { render } from "./myPage.vue?vue&type=template&id=081fb246&scoped=true"
import script from "./myPage.vue?vue&type=script&lang=js"
export * from "./myPage.vue?vue&type=script&lang=js"

import "./myPage.vue?vue&type=style&index=0&id=081fb246&lang=less&scoped=true"
import "./myPage.vue?vue&type=style&index=1&id=081fb246&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081fb246"]])

export default __exports__